import { getMultiButtonCta, getMultiButtonCtaWithSeparateLinks } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";

const multiButtonCtaConfig = (tinymce, uuid, shortcodeOnClick) => {
  const dialogData = {};
  const sameLinkConfig = {
    title: "Multi-Button CTA #1",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "url",
          label: "URL",
          placeholder: "https://domain.com",
        },
        {
          type: "selectbox",
          name: "tab",
          label: "Open link in...",
          items: [
            { value: "_self", text: "Same window tab" },
            { value: "_blank", text: "New window tab" },
          ],
        },
      ],
    },
    buttons: [
      {
        type: "custom",
        name: "back",
        text: "Previous",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onAction: (api, details) => {
      if (details.name === "back") {
        api.redial(firstStepWindowConfig);
      }
    },
    onSubmit: api => {
      dialogData.data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();
      const templateToAdd = getMultiButtonCta(dialogData);

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  };
  const separateLinksConfig = {
    title: "Multi-Button CTA #1",
    body: {
      type: "panel",
      items: [
        {
          type: "label",
          label: "Button 1 option",
          items: [
            {
              type: "input",
              name: "buttonInput1",
              inputMode: "text",
              label: "Button text",
              placeholder: "Button text",
            },
            {
              type: "input",
              name: "customUrl1",
              label: "URL",
              placeholder: "http://domain.com",
            },
            {
              type: "selectbox",
              name: "openLink1",
              label: "Open link in...",
              items: [
                { value: "_self", text: "Same window tab" },
                { value: "_blank", text: "New window tab" },
              ],
            },
          ],
        },
        {
          type: "label",
          label: "Button 2 option",
          items: [
            {
              type: "input",
              name: "buttonInput2",
              inputMode: "text",
              label: "Button text",
              placeholder: "Button text",
            },
            {
              type: "input",
              name: "customUrl2",
              label: "URL",
              placeholder: "http://domain.com",
            },
            {
              type: "selectbox",
              name: "openLink2",
              label: "Open link in...",
              items: [
                { value: "_self", text: "Same window tab" },
                { value: "_blank", text: "New window tab" },
              ],
            },
          ],
        },
        {
          type: "label",
          label: "Button 3 option",
          items: [
            {
              type: "input",
              name: "buttonInput3",
              inputMode: "text",
              label: "Button text",
              placeholder: "Button text",
            },
            {
              type: "input",
              name: "customUrl3",
              label: "URL",
              placeholder: "http://domain.com",
            },
            {
              type: "selectbox",
              name: "openLink3",
              label: "Open link in...",
              items: [
                { value: "_self", text: "Same window tab" },
                { value: "_blank", text: "New window tab" },
              ],
            },
          ],
        },
        {
          type: "label",
          label: "Button 4 option",
          items: [
            {
              type: "input",
              name: "buttonInput4",
              inputMode: "text",
              label: "Button text",
              placeholder: "Button text",
            },
            {
              type: "input",
              name: "customUrl4",
              label: "URL",
              placeholder: "http://domain.com",
            },
            {
              type: "selectbox",
              name: "openLink4",
              label: "Open link in...",
              items: [
                { value: "_self", text: "Same window tab" },
                { value: "_blank", text: "New window tab" },
              ],
            },
          ],
        },
      ],
    },
    buttons: [
      {
        type: "custom",
        name: "back",
        text: "Previous",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onAction: (api, details) => {
      if (details.name === "back") {
        api.redial(firstStepWindowConfig);
      }
    },
    onSubmit: api => {
      dialogData.data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();
      const templateToAdd = getMultiButtonCtaWithSeparateLinks(dialogData);

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  };
  const firstStepWindowConfig = {
    title: "Multi-Button CTA #1",
    body: {
      type: "panel",
      items: [
        {
          type: "selectbox",
          name: "quantity",
          label: "Button count",
          items: [
            { value: "4", text: "4" },
            { value: "5", text: "5" },
          ],
        },
        {
          type: "selectbox",
          name: "type",
          label: "Link option",
          items: [
            { value: "1", text: "Same link" },
            { value: "2", text: "Separate links" },
          ],
        },
      ],
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Next",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      dialogData.quantity = data.quantity;
      if (data.type === "1") {
        api.redial(sameLinkConfig);
      } else if (data.type === "2") {
        if (data.quantity === "5") {
          separateLinksConfig.body.items.push({
            type: "label",
            label: "Button 5 option",
            items: [
              {
                type: "input",
                name: "buttonInput5",
                inputMode: "text",
                label: "Button text",
                placeholder: "Button text",
              },
              {
                type: "input",
                name: "customUrl5",
                label: "URL",
                placeholder: "http://domain.com",
              },
              {
                type: "selectbox",
                name: "openLink5",
                label: "Open link in...",
                items: [
                  { value: "_self", text: "Same window tab" },
                  { value: "_blank", text: "New window tab" },
                ],
              },
            ],
          });
        }
        api.redial(separateLinksConfig);
      }
    },
  };

  tinymce.activeEditor.windowManager.open(firstStepWindowConfig);
};

export { multiButtonCtaConfig };
